import appAlertsReducer from './reducer';

export { default as appAlertsTypes } from './types';
export { default as appAlertsConfig } from './config';
export * from './actions';

export default appAlertsReducer;
